import React, {
  FC, useEffect, useRef, useState,
} from 'react';
import { FaXmark, FaCheck } from 'react-icons/fa6';
import {
  BackgroundImage,
} from './Styles';
import Header from '../../../Common/Header';
import { Australia } from '../../../../../assets/Base64Image';
import { Cab, Driver } from '../../../../../lib/types';
import { getFoodifoxDataLazy, updateFoodifoxData } from '../../../../../lib/axios/FoodifoxDataAPI';
import Logo from '../../../Common/Logo';
import Location from '../../../Common/Location';
import { getUserId } from '../../../../../lib/Authentication';
import SquadRegularText from '../../../../../components/Text/SquadRegularText';
import PingFangRegularText from '../../../../../components/Text/PingFangRegularText';
import SquadBoldText from '../../../../../components/Text/SquadBoldText';
import PingFangSemiBoldText from '../../../../../components/Text/PingFangSemiBoldText';
import Button from '../../../../../components/Button';
import SquadSemiBoldText from '../../../../../components/Text/SquadSemiBoldText';
import ColumnCenter from '../../../../../components/Layout/ColumnCenter';
import Row from '../../../../../components/Layout/Row';

const CreateDriver: FC<Props> = ({
  cabId32Str,
  deviceCode,
  isEnglish,
  setIsEnglish,
  cab,
  setShowLoading,
  setDriverId,
  setTargetPage,
  ckFirebaseId,
  onClose,
}) => {
  const [checkPhoneValid, { loading: checkPhoneLoading }] = getFoodifoxDataLazy('/foxH5Phone/checkPhoneValid');
  const [sendVerifyCodeLazy, { loading: sendVerifyCodeLoading }] = getFoodifoxDataLazy('/foxH5Phone/sendVerifyCode');
  const [checkVerifyCodeLazy, { loading: checkVerifyCodeLoading }] = getFoodifoxDataLazy('/foxH5Phone/checkVerifyCode');
  const [createDriverLazy, { loading: createLoading }] = updateFoodifoxData<Driver>('/foxH5Driver/createAndGetDriverId');

  const timeWaitRef = useRef<number>();

  const [verifyPhone, setVerifyPhone] = useState<string>();
  const [verifyCode, setVerifyCode] = useState<string>();
  const [phoneCheck, setPhoneCheck] = useState<boolean>();
  const [codeCheck, setCodeCheck] = useState<boolean>();
  const [timeWait, setTimeWait] = useState<string>();
  const [codeId, setCodeId] = useState<string>();

  useEffect(() => {
    setShowLoading(checkPhoneLoading || sendVerifyCodeLoading || checkVerifyCodeLoading || createLoading);

    return () => {
      setShowLoading(false);
    };
  }, [checkPhoneLoading || sendVerifyCodeLoading || checkVerifyCodeLoading, createLoading]);

  useEffect(() => {
    setInterval(() => {
      if (timeWaitRef.current != null && timeWaitRef.current <= 1) {
        timeWaitRef.current = undefined;
        setTimeWait(undefined);
        return;
      }
      if (timeWaitRef.current != null && timeWaitRef.current > 1) {
        timeWaitRef.current -= 1;
        setTimeWait(timeWaitRef.current.toFixed(0));
      }
    }, 1000);
  }, []);

  useEffect(() => {
    // 达到长度后自动触发验证验证码
    if (verifyCode != null && verifyCode.length >= 4) {
      checkVerifyCode();
    }
  }, [verifyCode]);

  /**
   * 发送验证码
   */
  const sendVerifyCode = () => {
    // 清空验证码
    setVerifyCode(undefined);

    // 倒计时没有结束时，不继续发送短信
    if (timeWaitRef.current != null && timeWaitRef.current > 0) {
      return;
    }
    if (verifyPhone == null || verifyPhone.trim().length < 9) {
      return;
    }

    // 验证手机号
    checkPhoneValid({
      param: {
        phoneNumber: verifyPhone,
        phoneCode: 'AU',
      },
      onError() {
        // 手机号码校验标识
        setPhoneCheck(false);
      },
      onCompleted() {
        // 手机号码校验标识
        setPhoneCheck(true);

        // 发送验证码
        sendVerifyCodeLazy({
          param: {
            phoneNumber: verifyPhone,
            phoneCode: 'AU',
          },
          onCompleted(resultData) {
            // 倒计时秒数
            timeWaitRef.current = 60;
            setTimeWait('60');
            // 设置验证码ID，验证验证码时需要用到
            setCodeId(resultData as any);
          },
        });
      },
    });
  };

  /**
   * 验证验证码
   */
  const checkVerifyCode = () => {
    if (verifyCode == null || verifyCode.trim().length < 4) {
      return;
    }
    if (verifyPhone == null || verifyPhone.trim().length < 9) {
      return;
    }

    checkVerifyCodeLazy({
      param: {
        id: codeId,
        code: verifyCode,
      },
      onError() {
        // 验证码校验标识
        setCodeCheck(false);
      },
      onCompleted() {
        // 验证码校验标识
        setCodeCheck(true);
      },
    });
  };

  /**
   * 创建司机
   */
  const createDriver = () => {
    if (verifyCode == null || verifyCode.trim().length < 4) {
      return;
    }
    if (verifyPhone == null || verifyPhone.trim().length < 9) {
      return;
    }

    if (!codeCheck) {
      return;
    }

    createDriverLazy({
      param: {
        phoneNumber: verifyPhone,
        phoneCode: 'AU',
        deviceCode,
        userAgent: navigator.userAgent,
        cabId: cabId32Str,
        firebaseId: getUserId(),
        ckFirebaseId,
      },
      onCompleted(driverData) {
        const { driverId } = driverData;
        setDriverId(driverId);
        setShowLoading(false);
        setTargetPage('food-platform-select');
      },
    });
  };

  return (
    <BackgroundImage>
      {/* 头部 */}
      <Header
        isEnglish={isEnglish}
        setIsEnglish={setIsEnglish}
        style={{ marginTop: '50px' }}
        supportIsOnlyCall={true}
        cabId32Str={cabId32Str}
      />

      {/* Logo */}
      <Logo onClose={onClose} backToPage={'home'} />

      {/* 地点 */}
      <Location isEnglish={isEnglish} cab={cab} style={{ marginTop: '25px' }} />

      {/* 提示验证手机号 */}
      <div style={{ width: '80%', marginTop: '35px', marginLeft: '10%', marginRight: '10%', textAlign: 'center' }}>
        {
          isEnglish ? (
            <SquadRegularText lineHeight={20}>
              Enter your phone number to verify
            </SquadRegularText>
          ) : (
            <PingFangRegularText lineHeight={22}>
              输入您的手机号进行验证
            </PingFangRegularText>
          )
        }
      </div>

      {/* 验证电话号码 */}
      <Row style={{ width: '85%', height: '72px', background: '#FFFFFF', borderRadius: '36px', border: '1px solid ' + (phoneCheck === false ? '#F00124' : '#11202B'), margin: '20px auto 0 auto', justifyContent: 'space-between' }}>
        <Row>
          <ColumnCenter style={{ height: '72px', alignItems: 'center', marginLeft: '25px' }}>
            <img src={Australia} style={{ width: '22px' }} />
          </ColumnCenter>
          <ColumnCenter style={{ height: '72px', alignItems: 'center', width: '26px', fontSize: '18px', lineHeight: '18px', fontFamily: 'Squad-Bold, Squad', fontWeight: 'bold', color: '#11202B', marginLeft: '5px' }}>
            +61
          </ColumnCenter>
        </Row>
        <ColumnCenter style={{ height: '72px', alignItems: 'center', width: '185px' }}>
          {
            <input
              style={{
                border: 'none',
                outline: 'none',
                fontSize: '18px',
                fontFamily: 'Squad-Regular, Squad',
                fontWeight: 400,
                color: '#11202B',
                backgroundColor: '#ffffff',
                lineHeight: '24px',
                textAlign: 'center',
                width: '130px',
              }}
              autoFocus={true}
              type="tel"
              inputMode="numeric"
              placeholder={isEnglish ? 'Mobile number' : '手机号码'}
              value={verifyPhone}
              onChange={(e) => {
                //去掉所有空格，重新设置文本款过的值
                setVerifyPhone(e.target.value.replace(/\s*/g, ""));
                setPhoneCheck(undefined);
                setCodeCheck(undefined);
              }}
            />
          }
        </ColumnCenter>
        <Row style={{ height: '72px', width: '53px', alignItems: 'center', justifyContent: 'flex-end', marginRight: '25px' }}>
          {
            phoneCheck && (
              <FaCheck style={{ color: '#00B595' }} />
            )
          }
          {
            phoneCheck === false && (
              <FaXmark style={{ color: '#F44336' }} />
            )
          }
        </Row>
      </Row>

      {/* 获取验证码按钮 */}
      <div id="getVerifyCodeBtnDiv">
        <Button
          width={214}
          height={60}
          backgroundColor={(createLoading || checkPhoneLoading || sendVerifyCodeLoading || checkVerifyCodeLoading || phoneCheck === false || timeWait != null || verifyPhone == null || verifyPhone.trim().length < 9) ? '#D0D0D0' : '#01B596'}
          disabled={createLoading || checkPhoneLoading || sendVerifyCodeLoading || checkVerifyCodeLoading || phoneCheck === false || timeWait != null || verifyPhone == null || verifyPhone.trim().length < 9}
          borderRadius={33}
          onClick={() => sendVerifyCode()}
          style={{ margin: '18px auto 0 auto', opacity: 1 }}
        >
          {
            isEnglish ? (
              <SquadBoldText fontSize={22} color={'#FFFFFF'} lineHeight={29}>
                Get a Code
              </SquadBoldText>
            ) : (
              <PingFangSemiBoldText fontSize={22} color={'#FFFFFF'} lineHeight={30}>
                获取验证码
              </PingFangSemiBoldText>
            )
          }
          <SquadSemiBoldText fontSize={16} color={'#FFFFFF'} lineHeight={22} marginLeft={5}>
            {timeWait != null ? '(' + timeWait + 's)' : ''}
          </SquadSemiBoldText>
        </Button>
      </div>

      {/* 验证码 */}
      <div>
        <div style={{ marginTop: '40px', textAlign: 'center' }}>
          {
            isEnglish ? (
              <SquadRegularText lineHeight={20}>
                Enter the verification code you recieved from SMS
              </SquadRegularText>
            ) : (
              <PingFangRegularText lineHeight={20}>
                输入短信中的’验证码’
              </PingFangRegularText>
            )
          }
        </div>
        <Row style={{ width: '85%', height: '72px', background: '#ffffff', borderRadius: '36px', border: '1px solid ' + (codeCheck === false ? '#F00124' : '#11202B'), margin: '20px auto 0 auto' }}>
          <div style={{ width: '50px' }}></div>
          <Row style={{ height: '72px', alignItems: 'center', width: '100%' }}>
            <input
              style={{
                width: '100%',
                border: 'none',
                outline: 'none',
                fontSize: '20px',
                fontFamily: 'Squad-Regular, Squad',
                fontWeight: 400,
                color: '#11202B',
                lineHeight: '26px',
                backgroundColor: '#ffffff',
                textAlign: 'center',

              }}
              type="tel"
              inputMode="numeric"
              placeholder={isEnglish ? 'Verify Code' : '验证码'}
              value={verifyCode}
              onChange={(e) => {
                let code = e.target.value.replace(/\s*/g, "");
                if (code.length > 4) {
                  code = code.substring(0, 4);
                }
                setVerifyCode(code);
                setCodeCheck(undefined);
              }}
            />
          </Row>
          <Row style={{ height: '72px', width: '14px', alignItems: 'center', marginRight: '25px' }}>
            {
              codeCheck && (
                <FaCheck style={{ color: '#00B595' }} />
              )
            }
            {
              codeCheck === false && (
                <FaXmark style={{ color: '#F44336' }} />
              )
            }
          </Row>
        </Row>
      </div>

      {/* 验证验证码按钮 */}
      <div style={{ paddingBottom: '50px' }}>
        <Button
          width={214}
          height={60}
          backgroundColor={(createLoading || checkPhoneLoading || sendVerifyCodeLoading || checkVerifyCodeLoading || codeCheck === false || verifyPhone == null || verifyPhone.trim().length < 9 || verifyCode == null || verifyCode.trim().length < 4) ? '#D0D0D0' : '#01B596'}
          disabled={createLoading || checkPhoneLoading || sendVerifyCodeLoading || checkVerifyCodeLoading || codeCheck === false || verifyPhone == null || verifyPhone.trim().length < 9 || verifyCode == null || verifyCode.trim().length < 4}
          borderRadius={33}
          onClick={() => createDriver()}
          style={{ margin: '18px auto 0 auto', opacity: 1 }}
        >
          {
            isEnglish ? (
              <SquadBoldText fontSize={18} color={'#FFFFFF'}>
                Verify
              </SquadBoldText>
            ) : (
              <PingFangSemiBoldText fontSize={18} color={'#FFFFFF'}>
                下一步
              </PingFangSemiBoldText>
            )
          }
        </Button>
      </div>
    </BackgroundImage>
  );
};

export interface Props {
  cabId32Str: string;
  deviceCode: string;
  isEnglish: boolean;
  setIsEnglish: (isEng: boolean) => void;
  cab: Cab;
  setShowLoading: (isShow: boolean) => void;
  setDriverId: (driverId: number) => void;
  setTargetPage: (targetPage: string) => void;
  ckFirebaseId?: string;
  onClose: () => void;
}

export default CreateDriver;
